module.exports = __webpack_public_path__ + "static/23-img-1-9be8c56bf2e54c1f6846292e10498501.png";